const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function qs(params) {
    const clean = Object.entries(params || {}).filter(
        ([, v]) => v !== undefined && v !== null && v !== "" && v !== false
    );
    if (!clean.length) return "";
    return `?${new URLSearchParams(clean).toString()}`;
}

async function parse(res) {
    let data = {};
    try {
        data = await res.json();
    } catch (e) {
        data = {};
    }
    if (!res.ok) {
        const detail = data.detail;
        const err = new Error(
            typeof detail === "string" ? detail : detail?.message || "Something went wrong. Please try again."
        );
        err.status = res.status;
        err.issues = typeof detail === "object" ? detail?.issues : undefined;
        throw err;
    }
    return data;
}

export async function apiGet(path, params) {
    const res = await fetch(`${API}${path}${qs(params)}`);
    return parse(res);
}

export async function apiPost(path, body) {
    const res = await fetch(`${API}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    return parse(res);
}

export const money = (n) =>
    `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const stripHtml = (html = "") => html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -90 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

export const CATEGORY_FALLBACK = {
    indica: "https://images.unsplash.com/photo-1457573294499-86ac96b336ba?crop=entropy&cs=srgb&fm=jpg&q=85",
    sativa: "https://images.unsplash.com/photo-1457573358540-3f57f7995c6c?crop=entropy&cs=srgb&fm=jpg&q=85",
    hybrid: "https://images.pexels.com/photos/29474295/pexels-photo-29474295.jpeg?auto=compress&cs=tinysrgb&q=85",
    exotics: "https://images.unsplash.com/photo-1634449277989-0e50ad2ca43e?crop=entropy&cs=srgb&fm=jpg&q=85",
    cartridges: "https://images.unsplash.com/photo-1781344116880-029945a42b75?crop=entropy&cs=srgb&fm=jpg&q=85",
    edibles: "https://images.pexels.com/photos/15360877/pexels-photo-15360877.jpeg?auto=compress&cs=tinysrgb&q=85",
    "psilocybin-mushroom": "https://images.pexels.com/photos/8139090/pexels-photo-8139090.jpeg?auto=compress&cs=tinysrgb&q=85",
    prerolls: "https://images.pexels.com/photos/12655421/pexels-photo-12655421.jpeg?auto=compress&cs=tinysrgb&q=85",
    merchandise: "https://images.pexels.com/photos/12672328/pexels-photo-12672328.jpeg?auto=compress&cs=tinysrgb&q=85",
    concentrates: "https://images.unsplash.com/photo-1600753230816-94fc22e82859?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1457573179814-451f407f0186?crop=entropy&cs=srgb&fm=jpg&q=85";

export const PROMO_IMAGE =
    "https://images.pexels.com/photos/12672328/pexels-photo-12672328.jpeg?auto=compress&cs=tinysrgb&q=85";
